export const categoryMap = {
    "amenity_library": {
      "objectId": "kChkWM0mGP",
      "value": "amenity_library",
      "nome": "Biblioteca",
      "createdAt": "2022-05-21T05:02:39.272Z",
      "updatedAt": "2022-05-21T05:02:39.272Z",
    },
    "tourism_museum": {
      "objectId": "yl7UnSowYO",
      "nome": "Museo",
      "value": "tourism_museum",
      "createdAt": "2022-05-22T05:18:49.132Z",
      "updatedAt": "2022-05-22T05:18:49.132Z",
    },
    "tourism_gallery": {
      "objectId": "STqs8W6nUM",
      "nome": "Galleria d'arte",
      "value": "tourism_gallery",
      "createdAt": "2022-05-22T05:29:52.431Z",
      "updatedAt": "2022-05-22T05:29:52.431Z",
    },
    "amenity_theatre": {
      "objectId": "ZpvCEYAHUc",
      "nome": "Teatro",
      "value": "amenity_theatre",
      "createdAt": "2022-05-22T05:36:35.758Z",
      "updatedAt": "2022-05-22T05:36:35.758Z",
    },
    "amenity_hospital": {
      "objectId": "VXv9AXNENF",
      "nome": "Centro sanitario",
      "value": "amenity_hospital",
      "createdAt": "2022-05-22T05:38:55.920Z",
      "updatedAt": "2022-05-22T05:38:55.920Z",
    },
    "amenity_school": {
      "objectId": "O7UlOJqNLO",
      "nome": "Centro scolastico",
      "value": "amenity_school",
      "createdAt": "2022-05-22T05:40:38.917Z",
      "updatedAt": "2022-05-22T05:40:38.917Z",
    },
    "amenity_post_office": {
      "objectId": "x7hfg7kzVF",
      "nome": "Ufficio Postale",
      "value": "amenity_post_office",
      "createdAt": "2022-05-22T05:50:46.939Z",
      "updatedAt": "2022-05-22T05:50:46.939Z",
    },
    "amenity_police": {
      "objectId": "NVqLQ2fSDo",
      "nome": "Polizia",
      "value": "amenity_police",
      "createdAt": "2022-05-22T05:53:02.434Z",
      "updatedAt": "2022-05-22T05:53:02.434Z",
    },
    "amenity_pharmacy": {
      "objectId": "YyqzqqJqwq",
      "nome": "Farmacia",
      "value": "amenity_pharmacy",
      "createdAt": "2022-05-22T05:54:10.284Z",
      "updatedAt": "2022-05-22T05:54:10.284Z",
    },
    "amenity_clinic": {
      "objectId": "U5Q1JpvqPA",
      "nome": "Sede comunale",
      "value": "amenity_clinic",
      "createdAt": "2022-05-22T05:55:23.311Z",
      "updatedAt": "2022-05-22T05:55:23.311Z",
    },
    "amenity_cinema": {
      "objectId": "LN43fACIXo",
      "nome": "Cinema",
      "value": "amenity_cinema",
      "createdAt": "2022-05-22T05:56:20.121Z",
      "updatedAt": "2022-05-22T05:56:20.121Z",
    },
    "social_facility": {
      "objectId": "DVHVOkrdJg",
      "nome": "Servizio informagiovani",
      "value": "social_facility",
      "createdAt": "2022-05-22T05:58:11.379Z",
      "updatedAt": "2022-05-22T05:58:11.379Z",
    },
  
    "amenity_church": {
      "objectId": "nUFHd9Nfk4",
      "nome": "Chiesa",
      "value": "amenity_church",
      "createdAt": "2022-05-22T06:55:10.676Z",
      "updatedAt": "2022-05-22T06:55:10.676Z",
    },
    "bicycle_store": {
      "objectId": "nyAFZPdBl2",
      "nome": "Ciclista",
      "value": "bicycle_store",
      "createdAt": "2022-05-22T07:32:40.763Z",
      "updatedAt": "2022-05-22T07:32:40.763Z",
    },
  };